// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"e890d62f","272":"aad4c2d3","539":"aad4c2d3","981":"3097b10b"}[chunkId] + ".chunk.css";
};